import _, { get } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import submit from "submit-form";
import Select from "react-select";
import Modal from "../../../parts/modal-new";
import { S3, defaultFirebaseProjectId } from "../../../constants";
import getAvatarUrl from "../../../utils/get-avatar-url";
import FilterChips from "../../athlete-portal/calendar/FilterChips";
import SvgIcon from "../../../parts/SvgIcon";
import { SearchDropdown } from "../../../parts/inputs/search-dropdown";
import { option } from "commander";

class SendModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { locals } = context;
    const { isAllowToViewAllOrganizationsAthletes } = props;

    const {
      activeUser: { athletes },
      allAthletesFromOrganization,
    } = locals;
    const referAsClients = Boolean(locals.activeUser.referAsClients);

    const athletesOptions = [];
    athletes
      .filter(({ status }) => !status?.inactive)
      .forEach((athlete) => {
        athletesOptions.push({
          value: athlete._id,
          label: athlete.name,
          groups: athlete.groups || [],
          avatar: athlete.avatar,
        });
      });

    const allAthletesFromOrganizationOptions = [];
    if (allAthletesFromOrganization && isAllowToViewAllOrganizationsAthletes) {
      const uniqueAthleteIds = new Set();
      allAthletesFromOrganization
        .filter(({ athleteStatus }) => !athleteStatus?.inactive)
        .forEach(({ athleteId, athleteName, athleteGroups, athleteAvatar }) => {
          if (!uniqueAthleteIds.has(athleteId)) {
            uniqueAthleteIds.add(athleteId);
            allAthletesFromOrganizationOptions.push({
              value: athleteId,
              label: athleteName,
              groups: athleteGroups || [],
              avatar: athleteAvatar,
            });
          }
        });
      uniqueAthleteIds.clear();
    }

    this.state = {
      selectedAthletes: [],
      activeAthleteCycles: [],
      athletesOptions,

      showConfirm: false,
      submited: false,
      referAsClients,
      allAthletesFromOrganizationOptions,
      isAllowToViewAllOrganizationsAthletes,
      isSearching: false,
    };
    this.handleClearAll = this.handleClearAll.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.searchAthletes = this.searchAthletes.bind(this);
    this.generateAthleteListItem = this.generateAthleteListItem.bind(this);
  }

  generateAthleteListItem(athlete, getImgUrl) {
    return (
      <li
        key={`${athlete.value}`}
        onClick={
          this.state.selectedAthletes.find(
            (item) => item.value === athlete.value
          )
            ? () =>
                this.handleAthleteChange(
                  this.state.selectedAthletes.filter(
                    (ath) => ath.value !== athlete.value
                  )
                )
            : () =>
                this.handleAthleteChange([
                  ...this.state.selectedAthletes,
                  athlete,
                ])
        }
      >
        <img
          src={getImgUrl(athlete)}
          style={
            getImgUrl(athlete) === "/img/new-icons/user-circle.svg"
              ? {
                  backgroundColor: "var(--background-color)",
                  padding: "8px",
                }
              : {}
          }
        />
        {athlete.label}
      </li>
    );
  }

  // function to filter the athletes in the mobile screen
  searchAthletes = (value) => {
    const label = value.toString().toLowerCase();
    const originalList =
      this.state.allAthletesFromOrganizationOptions.length > 0
        ? this.state.allAthletesFromOrganizationOptions.sort((a, b) =>
            a.label.localeCompare(b.label)
          )
        : this.state.athletesOptions;

    const filteredArray = originalList.filter((item) =>
      item.label.toLowerCase().startsWith(label)
    );

    this.setState({
      athletesOptions: value ? filteredArray : originalList,
    });
  };

  isAFilterActive() {
    const { athletesGroups } = this.context.locals.activeUser;
    return (
      this.state.allAthletes ||
      this.state.allOrganizationAthletes ||
      athletesGroups?.some((elem) => this.state[elem.name])
    );
  }

  // if there is not selected athletes disable filters
  clearFilters() {
    if (this.state.selectedAthletes.length === 0 && this.isAFilterActive()) {
      const filters = { allAthletes: false, allOrganizationAthletes: false };
      const { athletesGroups } = this.context.locals.activeUser;
      athletesGroups &&
        athletesGroups.forEach((elem) => (filters[elem.name] = false));
      this.setState(filters);
    }
  }

  handleInputChange(value, name) {
    const {
      selectedAthletes,
      athletesOptions,
      allAthletesFromOrganizationOptions,
      isAllowToViewAllOrganizationsAthletes,
    } = this.state;
    let selection = [...selectedAthletes];

    const currentCoachAthletes =
      allAthletesFromOrganizationOptions.length > 0 &&
      isAllowToViewAllOrganizationsAthletes
        ? allAthletesFromOrganizationOptions.filter((athlete) =>
            athletesOptions.some((option) => option.value === athlete.value)
          )
        : athletesOptions;

    if (name === "allAthletes" && value) {
      // select all athletes
      selection = currentCoachAthletes;
    } else if (
      (name === "allAthletes" || name === "allOrganizationAthletes") &&
      !value
    ) {
      // clean selection
      selection = [];
    } else if (name === "allOrganizationAthletes" && value) {
      selection = allAthletesFromOrganizationOptions;
    } else if (value) {
      // filter by group

      selection =
        allAthletesFromOrganizationOptions.length > 0 &&
        isAllowToViewAllOrganizationsAthletes
          ? [
              ...selection,
              ...allAthletesFromOrganizationOptions.filter((elem) =>
                elem.groups.includes(name)
              ),
            ]
          : [
              ...selection,
              ...this.state.athletesOptions.filter((elem) =>
                elem.groups.includes(name)
              ),
            ];
    } else {
      // unselect by group
      selection = selection.filter((elem) => !elem.groups.includes(name));
    }

    this.setState({
      [name]: value,
      selectedAthletes: _.uniq(selection),
      refresh: !this.state.refresh,
    });
  }

  handleAthleteChange(recipient) {
    // If user is removed from list
    if (recipient[0] === undefined)
      this.setState(
        {
          selectedAthletes: [],
          activeAthleteCycles: [],
        },
        () => {
          this.clearFilters();
        }
      );
    else {
      // Setting Active cycle to iterate through.
      const { athleteCycles } = this.context.locals;
      // These are the filtered cycles for the selected athlete.
      athleteCycles.filter((cycle) => {
        // If the selected athlete is the owner of the current cycle its added to their active
        if (cycle.owner._id === recipient[0].value) {
          this.setState((prevState) => ({
            activeAthleteCycles: [
              ...prevState.activeAthleteCycles,
              {
                _id: cycle._id,
                name: cycle.name,
              },
            ],
          }));
        }
        // Set the selected athletes
        this.setState({
          selectedAthletes: recipient,
        });
      });
    }
  }

  handleCycleKindChange(value) {
    this.setState({ cycleKind: value });
  }

  send({
    cycleId,
    destinationCycleId,
    programOrder,
    selectedAthletes,
    push,
    submited,
    e,
  }) {
    e.preventDefault();
    if (submited) return;
    this.setState({ submited: true });
    const { activeUserToRequest, activeUser } = this.context.locals;
    submit(`/actions/cycle/send`, {
      method: "POST",
      body: {
        cycleId,
        destinationCycleId,
        programOrder,
        recipients: selectedAthletes.map((ath) => ath.value),
        push,
        avatar:
          !!activeUser.avatar && !!activeUser.avatar.file
            ? activeUser.avatar.file
            : null,
        firebaseProjectId: !!activeUserToRequest.firebaseProjectId
          ? activeUserToRequest.firebaseProjectId
          : defaultFirebaseProjectId,
      },
    });
  }

  handleClearAll() {
    this.setState({ selectedAthletes: [] }, () => {
      this.clearFilters();
    });
  }

  showSend() {
    const {
      selectedAthletes,
      athletesOptions,
      activeAthleteCycles,
      destinationCycleId,
      cycleKind = "new",
      isAllowToViewAllOrganizationsAthletes,
      allAthletesFromOrganizationOptions,
      allAthletes,
      allOrganizationAthletes,
      isSearching,
    } = this.state;
    const { locals } = this.context;
    const referAsClients = locals.activeUser.referAsClients;
    const {
      query = {},
      athleteCycles,
      activeUser: { athletesGroups },
    } = locals;
    let { cycleId, programOrder } = query;

    const cycle = _.find(athleteCycles, { _id: cycleId });
    const program =
      programOrder && cycle && _.find(cycle.programs, { order: programOrder });
    const hasRequiredInputs = !!cycle && (programOrder ? !!program : true);

    const existingCycleOptions = _.map(activeAthleteCycles, (cycle) => ({
      value: cycle._id,
      label: cycle.name,
    }));

    const isValid =
      hasRequiredInputs &&
      selectedAthletes.length > 0 &&
      (cycleKind === "new" || destinationCycleId);
    const getImgUrl = (athlete) => {
      if (
        selectedAthletes.find((selected) => selected.value === athlete.value)
      ) {
        return "/img/new-icons/tick-circle.svg";
      } else {
        if (athlete.avatar) {
          return `${S3.PATH}${athlete.avatar.s3Path}`;
        } else return "/img/new-icons/user-circle.svg";
      }
    };

    return (
      <Modal
        toClear={["cycleId", "programOrder", "recipient", "sendToAnother"]}
        className="send-program-modal"
        title={`Send ${programOrder ? "Block" : "Program"}`}
      >
        {hasRequiredInputs && (
          <div className="body">
            <div className="left">
              {/* select group for desktop */}
              <div>
                <SelectGroupForDesktop
                  handleInputChange={this.handleInputChange}
                  state={this.state}
                  allAthletesFromOrganizationOptions={
                    allAthletesFromOrganizationOptions
                  }
                  isAllowToViewAllOrganizationsAthletes={
                    isAllowToViewAllOrganizationsAthletes
                  }
                  athletesGroups={athletesGroups}
                />
                {/* select group for mobile */}
                <SelectGroupForMobile
                  handleInputChange={this.handleInputChange}
                  state={this.state}
                  allAthletesFromOrganizationOptions={
                    allAthletesFromOrganizationOptions
                  }
                  isAllowToViewAllOrganizationsAthletes={
                    isAllowToViewAllOrganizationsAthletes
                  }
                  athletesGroups={athletesGroups}
                />
                <SearchAthletesForMobile
                  handleInputChange={this.handleInputChange}
                  allAthletes={allAthletes}
                  allAthletesFromOrganizationOptions={
                    allAthletesFromOrganizationOptions
                  }
                  allOrganizationAthletes={allOrganizationAthletes}
                  searchAthletes={this.searchAthletes}
                  referAsClients={referAsClients}
                />
                <section>
                  <header>
                    {isSearching ? (
                      <>
                        <input
                          type="search"
                          className="mobile-hidden"
                          name="search"
                          placeholder="Search"
                          onChange={(e) => this.searchAthletes(e.target.value)}
                          data-expandable="true"
                        />
                        <SvgIcon
                          role="button"
                          data-button-type="text-white"
                          data-icon-only="true"
                          data-icon
                          sz="small"
                          onClickFn={() => {
                            this.searchAthletes("");
                            this.setState({
                              isSearching: false,
                            });
                          }}
                          src="/img/new-icons/close-search.svg"
                        />
                      </>
                    ) : (
                      <p
                        className="p4 "
                        onClick={() => this.setState({ isSearching: true })}
                      >
                        <span>
                          Send a copy of{" "}
                          <strong>
                            {programOrder ? program.name : cycle.name}
                          </strong>{" "}
                          to one or multiple{" "}
                          {this.state.referAsClients ? "clients" : "athletes"}.
                          This will create a new copy in the recipient's{" "}
                          {this.state.referAsClients ? "Client" : "Athlete"}{" "}
                          Portal.
                        </span>
                      </p>
                    )}
                  </header>

                  {/* list for desktop (render all the athletes) */}
                  <ul className="athlete-select ">
                    {athletesOptions.length > 0 &&
                      athletesOptions.map((athlete) => {
                        return this.generateAthleteListItem(athlete, getImgUrl);
                      })}
                  </ul>
                </section>
              </div>
              {programOrder && selectedAthletes.length > 0 && (
                <div className="Add-Cycle">
                  <p className="p4">Choose cycle to copy program to:</p>
                  <div className="group">
                    <label className="radio-input">
                      <input
                        name="cycleKind"
                        type="radio"
                        checked={cycleKind === "new"}
                        onChange={() => this.handleCycleKindChange("new")}
                      />

                      <span className="text">Create new</span>
                    </label>
                    {selectedAthletes.length === 1 && (
                      <label className="radio-input">
                        <input
                          name="cycleKind"
                          type="radio"
                          checked={cycleKind === "existing"}
                          onChange={() =>
                            this.handleCycleKindChange("existing")
                          }
                          disabled={selectedAthletes.length > 1}
                          readOnly={selectedAthletes.length > 1}
                        />

                        <span className="text">Choose existing</span>
                      </label>
                    )}
                  </div>
                </div>
              )}
              {selectedAthletes.length === 1 && cycleKind === "existing" && (
                <div className="athlete-select" style={{ marginTop: "20px" }}>
                  <SearchDropdown
                    value={
                      existingCycleOptions.find(
                        (option) => option.value === destinationCycleId
                      )?.label || null
                    }
                    options={existingCycleOptions}
                    handleChange={(cycle) => {
                      this.setState({ destinationCycleId: cycle.value });
                    }}
                    placeholder="Select Block"
                    valueKey="label"
                  />
                </div>
              )}
            </div>
            <div className="right">
              <header>
                <h3>
                  Selected {this.state.referAsClients ? "Clients" : "Athletes"}
                </h3>
                <button
                  data-button-type="secondary"
                  disabled={selectedAthletes.length === 0}
                  onClick={this.handleClearAll}
                >
                  Clear all
                </button>
              </header>
              <ul className="mb-6">
                <FilterChips
                  filters={selectedAthletes.map((athlete) => ({
                    text: athlete.label,
                    id: athlete.value,
                  }))}
                  clearFilter={(id) => {
                    this.setState({
                      selectedAthletes: selectedAthletes.filter(
                        (athlete) => athlete.value !== id
                      ),
                    });
                  }}
                />
              </ul>
              <div>
                {!hasRequiredInputs && (
                  <div>
                    <p>No cycle or program to send</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <footer>
          <div>
            <p className="chip warning text-[0.75rem]">
              Push: this sends an exact copy of the template directly to your{" "}
              {this.state.referAsClients ? "clients" : "athlete"}(s). You cannot
              edit this program before pushing with this option
            </p>
            <p className="chip warning text-[0.75rem]">
              Copy To: this makes a copy of the template to the
              {this.state.referAsClients ? " client" : " athlete"}'s program
              page where you can make edits to the template before pushing it to
              them.
            </p>
          </div>

          <div>
            <button
              data-button-type="outline"
              disabled={!isValid || undefined}
              type="submit"
              onClick={(e) => this.setState({ showConfirm: true })}
            >
              <span>Push</span>
            </button>
            <button
              type="submit"
              data-button-type="primary"
              disabled={!isValid || undefined}
              onClick={(e) =>
                this.send({
                  cycleId,
                  destinationCycleId,
                  programOrder,
                  selectedAthletes,
                  submited: this.state.submited,
                  e,
                })
              }
            >
              Copy
            </button>
          </div>
        </footer>
      </Modal>
    );
  }

  showConfirmation() {
    const { destinationCycleId } = this.state;
    const { locals } = this.context;
    const { activeUser } = locals;
    const referAsClients = Boolean(activeUser.referAsClients);
    const { query } = locals;

    let { cycleId, programOrder } = query;
    const { selectedAthletes } = this.state;
    return (
      <Modal
        width="600px"
        title={"Confirm Send & Push"}
        className={"confirm-push-block"}
      >
        <div className="body">
          <h4>By pushing this program you confirm that:</h4>
          <ul>
            <li>
              Your {referAsClients ? "clients" : "athletes"} will now see the
              program in their account.
            </li>
            <li>
              You will no longer be able to edit this program but you can still
              duplicate it and edit the duplicated copy.
            </li>
            <li>
              The {referAsClients ? "clients" : "athletes"} will receive the
              program. They will need to add it to their calendar before you can
              view or edit the program in their calendar. This is useful if you
              want to make updates throughout the program.
            </li>
          </ul>
        </div>

        <footer>
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            href="/actions/refresh?modal="
          >
            Cancel
          </a>
          <button
            role="button"
            data-button-type="primary"
            onClick={(e) =>
              this.send({
                cycleId,
                destinationCycleId,
                programOrder,
                selectedAthletes,
                push: true,
                submited: this.state.submited,
                e,
              })
            }
          >
            Confirm
          </button>
        </footer>
      </Modal>
    );
  }

  render() {
    const { showConfirm } = this.state;

    if (!showConfirm) {
      return this.showSend();
    }

    return this.showConfirmation();
  }
}

SendModal.contextTypes = { locals: PropTypes.object };

export default SendModal;

const SelectGroupForDesktop = ({
  handleInputChange,
  state,
  allAthletesFromOrganizationOptions,
  isAllowToViewAllOrganizationsAthletes,
  athletesGroups,
}) => {
  return (
    <fieldset className="select-by-group">
      <legend className="select-title">Select by group</legend>
      <div className="select-group-filters">
        <div
          className="select-group-filter"
          onClick={() => handleInputChange(!state.allAthletes, "allAthletes")}
        >
          <img
            src={`/img/new-icons/${
              state.allAthletes ? "checked" : "unchecked"
            }-square.svg`}
          />
          All {state.referAsClients ? "Clients" : "Athletes"}
        </div>
        {allAthletesFromOrganizationOptions.length > 0 &&
          isAllowToViewAllOrganizationsAthletes && (
            <div
              className="select-group-filter"
              onClick={() =>
                handleInputChange(
                  !state.allOrganizationAthletes,
                  "allOrganizationAthletes"
                )
              }
            >
              <img
                src={`/img/new-icons/${
                  state.allOrganizationAthletes ? "checked" : "unchecked"
                }-square.svg`}
              />
              All Organization {state.referAsClients ? "Clients" : "Athletes"}
            </div>
          )}
        {athletesGroups &&
          athletesGroups.map((elem) => (
            <div
              className="select-group-filter"
              onClick={() => handleInputChange(!state[elem.name], elem.name)}
            >
              <img
                src={`/img/new-icons/${
                  state[elem.name] ? "checked" : "unchecked"
                }-square.svg`}
              />
              {elem.name}
            </div>
          ))}
      </div>
    </fieldset>
  );
};

const SelectGroupForMobile = ({
  handleInputChange,
  state,
  allAthletesFromOrganizationOptions,
  isAllowToViewAllOrganizationsAthletes,
  athletesGroups,
}) => {
  return (
    <div className="select-by-group-mobile force-only-show-mobile">
      <button
        type="button"
        className={
          state.allAthletes
            ? `select-group-filter-mobile active-select`
            : `select-group-filter-mobile`
        }
        onClick={() => handleInputChange(!state.allAthletes, "allAthletes")}
      >
        All {state.referAsClients ? "Clients" : "Athletes"}
      </button>
      {allAthletesFromOrganizationOptions.length > 0 &&
        isAllowToViewAllOrganizationsAthletes && (
          <button
            type="button"
            className={
              state.allOrganizationAthletes
                ? `select-group-filter-mobile active-select`
                : `select-group-filter-mobile`
            }
            onClick={() =>
              handleInputChange(
                !state.allOrganizationAthletes,
                "allOrganizationAthletes"
              )
            }
          >
            All Organization {state.referAsClients ? "Clients" : "Athletes"}
          </button>
        )}
      {athletesGroups &&
        athletesGroups.map((elem) => (
          <button
            type="button"
            className={
              state[elem.name]
                ? `select-group-filter-mobile active-select`
                : `select-group-filter-mobile`
            }
            onClick={() => handleInputChange(!state[elem.name], elem.name)}
          >
            {elem.name}
          </button>
        ))}
    </div>
  );
};

const SearchAthletesForMobile = ({
  handleInputChange,
  allAthletes,
  allAthletesFromOrganizationOptions,
  allOrganizationAthletes,
  searchAthletes,
  referAsClients,
}) => {
  const isAllAthletesFromOrganizationOptionsEmpty =
    allAthletesFromOrganizationOptions.length === 0;

  const handleClick = () => {
    if (isAllAthletesFromOrganizationOptionsEmpty) {
      handleInputChange(!allAthletes, "allAthletes");
    } else {
      handleInputChange(!allOrganizationAthletes, "allOrganizationAthletes");
    }
  };

  const athletesToSelect = isAllAthletesFromOrganizationOptionsEmpty
    ? allAthletes
    : allOrganizationAthletes;
  return (
    <div className="force-only-show-mobile" id="search-athlete-select">
      <input
        name="search"
        type="search"
        // value={search}
        onChange={(e) => searchAthletes(e.target.value)}
        placeholder={`Search ${referAsClients ? "client" : "athlete"}`}
        autoComplete="off"
      />
      <div>
        <img
          src={
            athletesToSelect
              ? "/img/new-icons/checked-square.svg"
              : "/img/new-icons/unchecked-square.svg"
          }
          onClick={handleClick}
        />
        <span>Select all</span>
      </div>
    </div>
  );
};
